import { render, staticRenderFns } from "./AddToCartBtn.vue?vue&type=template&id=bb344fe2&scoped=true"
import script from "./AddToCartBtn.vue?vue&type=script&lang=js"
export * from "./AddToCartBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb344fe2",
  null
  
)

export default component.exports